import { SCREENSAVER_MODE } from '../actionConstants';
import { ScreensaverMode } from './screensaverTypes';
import { Action } from '../../generalTypes';

/**
 * Selects screensaver mode state slice
 * @param mode
 */
export const actionSetScreensaverMode = (
  mode: ScreensaverMode
): Action<ScreensaverMode> => ({
  type: SCREENSAVER_MODE,
  payload: mode,
});
